package org.example.zone360.pages.dashboard.coaches

import org.example.zone360.components.debugPrintln

import org.example.zone360.utils.adminRequestAssessment
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.utils.existingAssessment
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CommonDropdown
import org.example.zone360.components.CustomDatePicker
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.ProgressIndicator
import org.example.zone360.components.SearchBar
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormal
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.AdminRequestAssessmentPayload
import org.example.zone360.models.ExistingAssessmentPayload
import org.example.zone360.models.GetPlayerData
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Constants
import org.example.zone360.utils.Res
import org.example.zone360.utils.Strings
import org.example.zone360.utils.ToastID
import org.example.zone360.utils.dateToMillis
import org.example.zone360.utils.getCurrentMilliseconds
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.example.zone360.utils.requestAssessment


@Composable
fun AssessmentPopup(
    onDialogDismiss: () -> Unit,
    toastMessage: (String) -> Unit,
    onSaveChanges: () -> Unit,
    breakpoint: Breakpoint,
    playerData: List<GetPlayerData>,
    coachId: String,
    coachName: String,
    coachEmail: String,
    initialRequestType: String

) {
    val scope = rememberCoroutineScope()
    val sitePalette = ColorMode.current.toSitePalette()

    var isLoading by remember { mutableStateOf(false) }
    var isButton by remember { mutableStateOf(false) }
    var serverError by remember { mutableStateOf("") }
    var selectedActionError by remember { mutableStateOf(false) }
    var dateTimeError by remember { mutableStateOf(false) }
    var searchText by remember { mutableStateOf("") }
    var selectdate by remember { mutableStateOf("") }
    var assessmentSenderIds by remember { mutableStateOf<Set<String>>(emptySet()) }

    LaunchedEffect(Unit) {
        try {
            val payload = ExistingAssessmentPayload(
                userId = coachId,
                organization = AppGlobal.userData.organization,
                requestedBy = "admin",
                seasonID = AppGlobal.selectedSeasonId
            )

            val response = existingAssessment(payload)

            // Collect sender IDs
            assessmentSenderIds = response.data
                .map { it.senderId }
                .toSet()

        } catch (e: Exception) {
            debugPrintln("Existing assessment error: ${e.message}")
        }
    }

    var selectedRequestType by remember {
        mutableStateOf(
            initialRequestType.ifBlank { "Request Assessment" }
        )
    }
    val isRequestLocked = initialRequestType.isNotBlank()

    val filteredPlayers = playerData.filter { player ->
        val query = searchText.trim().lowercase()

        query.isEmpty() ||
                player.firstName.lowercase().contains(query) ||
                player.lastName.lowercase().contains(query) ||
                player.email.lowercase().contains(query)
    }


    val headingText = when (selectedRequestType) {
        "Request Assessment" -> "Request Assessment"
        else -> selectedRequestType
    }


    Box(
        modifier = Modifier
            .width(if (breakpoint < Breakpoint.MD) 350.px else 450.px)
            .position(Position.Fixed)
            .zIndex(99999)
            .top(50.percent)
            .left(50.percent)
            .transform { translate((-50).percent, (-50).percent) },
        contentAlignment = Alignment.Center,
    ) {
        Box(
            modifier = Modifier
                .width(90.percent)
        )
        Box(
            modifier = Modifier
                .padding(all = 24.px)
                .width(90.percent)
                .margin(top = 10.px)
                .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .border(
                    width = 1.px,
                    color = sitePalette.textFieldBorderColor.rgb,
                    style = LineStyle.Solid
                )
                .borderRadius(4.px)
//                .overflow(Overflow.Auto)
            ,
            contentAlignment = Alignment.Center,
        ) {
            Column(modifier = Modifier.fillMaxWidth()) {
                Row(
                    horizontalArrangement = Arrangement.SpaceBetween,
                    modifier = Modifier
                        .fillMaxWidth()
                        .margin(bottom = 20.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Column {
                        FieldTitleTextNormalSimple(
                            text = headingText,
                            fontSize = 20.px,
                            fontWeight = 600,
                            onClick = {}
                        )
                    }

                    FaXmark(
                        modifier = Modifier
                            .color(sitePalette.commonButtonSupportiveTextColor.rgb)
                            .cursor(Cursor.Pointer)
                            .onClick { onDialogDismiss() },
                        size = IconSize.LG
                    )

                }
                Column(modifier = Modifier.fillMaxWidth().margin(bottom = 20.px)) {
                    CommonDropdown(
                        data = Strings.REQUEST_OPTIONS,
                        onSelect = {
                            selectedRequestType = it
                            selectedActionError = false
                        },
                        selectedItem = selectedRequestType,
                        disabled = isRequestLocked,
                        width = 100.percent,
                    )
                    if (selectedActionError) {
                        FieldTitleTextNormal(marginTop = 3.px,
                            fontSize = 11.px,
                            text = "Please select at least one request",
                            color = sitePalette.textErrorColor.rgb,
                            onClick = {})
                    }
                }
                if (selectedRequestType == "Request Assessment"){
                    Row(
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        SearchBar(
                            placeholder = "Search Player...",
                            id = "session_Searchbar",
                            breakpoint = Breakpoint.LG,
                            onEnterClick = {},
                            onChange = { newSearchText ->
                                searchText = newSearchText
                            },
                            onClick = {},
                            width = 100.percent,
                            showClearButton = false,
                            height = 48.px,
                            borderColor = Colors.Transparent
                        )
                    }
                }
                if (selectedRequestType == "Request Assessment"){
                    Column(
                        modifier = Modifier.fillMaxWidth().height(if (breakpoint <= Breakpoint.LG) 310.px else 490.px)
                            .overflow(if (isLoading) Overflow.Hidden else Overflow.Auto)
                    ) {
                        Box(modifier = Modifier.fillMaxSize()) {
                            if (isLoading) {
                                Box(
                                    modifier = Modifier.fillMaxSize(),
                                    contentAlignment = Alignment.Center
                                ) {
                                    ProgressIndicator()
                                }
                            }
                            Column(Modifier.fillMaxWidth().padding(leftRight = 20.px)) {
                                filteredPlayers.forEach { data ->
                                    val hasExistingAssessment = assessmentSenderIds.contains(data.userId)

                                    CustomSpacer(height = 10.px)
                                    Column(modifier = Modifier.fillMaxWidth().margin(topBottom = 6.px)
                                        .cursor(if (isLoading) Cursor.Default else Cursor.Pointer)
                                        .onClick {
                                            if (!isLoading) {
                                                scope.launch {
                                                    isLoading = true
                                                    val request = requestAssessment(
                                                        coachID = coachId,
                                                        coachName = coachName,
                                                        coachEmail = coachEmail,
                                                        playerName = data.firstName + " " + data.lastName,
                                                        playerEmail = data.email,
                                                        organization = AppGlobal.userData.organization,
                                                        playerID = data.userId,
                                                        requestedBy = Strings.ADMIN

                                                    )
                                                    if (request.response != "") {
                                                        isLoading = false
                                                        toastMessage(request.response)
                                                        showToast("toastSuccess")
                                                        AppGlobal.updateNotifications = getCurrentMilliseconds().toString()
                                                    } else {
                                                        isLoading = false
                                                        toastMessage(request.error)
                                                        showToast("toastError")
                                                    }
                                                }
                                            }

                                        }) {
                                        Row(
                                            modifier = Modifier.fillMaxWidth(),
                                            horizontalArrangement = Arrangement.SpaceBetween,
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {
                                            if (data.imageUrl.isNotEmpty()) {
                                                Image(
                                                    src = "${Res.Images.base_Image_Url}${data.imageUrl}",
                                                    modifier = Modifier.size(30.px)
                                                        .margin(right = 5.px)
                                                        .borderRadius(100.px)
                                                        .textAlign(TextAlign.Start)
                                                )
                                            } else {
                                                Image(
                                                    src = Res.Images.userIcon,
                                                    modifier = Modifier.size(30.px)
                                                        .margin(right = 7.px)
                                                        .borderRadius(100.px)
                                                )
                                            }
                                            Column(modifier = Modifier.weight(1f)) {
                                                Row(
                                                    modifier = Modifier.fillMaxWidth(),
                                                    verticalAlignment = Alignment.CenterVertically
                                                ) {
                                                    FieldTitleTextNormalSimple(
                                                        "${data.firstName} ${data.lastName}",
                                                        fontFamily = Constants.IBM_FONT,
                                                        fontSize = 14.px,
                                                        fontWeight = 500,
                                                        isClickable = !isLoading
                                                    )
                                                    if (hasExistingAssessment) {
                                                        Image(
                                                            src = Res.Images.document_black,
                                                            modifier = Modifier.size(16.px)
                                                                .margin(left = 8.px)
                                                        )
                                                    }
                                                }
                                                FieldTitleTextNormalSimple(
                                                    data.email,
                                                    fontFamily = Constants.IBM_FONT,
                                                    fontSize = 12.px,
                                                    color = Colors.Gray,
                                                    isClickable = !isLoading,
                                                    width = 100.percent
                                                )
                                            }


                                        }
                                    }
                                }
                            }
                        }
                    }
                } else {
                    Column(modifier = Modifier.fillMaxWidth().margin(bottom = 20.px)) {
                        CustomDatePicker(
                            id = "assessment-date-picker",
                            width = 100.percent,
                            value = selectdate,
                            placeHolder = Strings.YYYY_MM_DD,
                            onValueChange = {
                                selectdate = it
                                dateTimeError = false
                            }
                        )
                        if (dateTimeError) {
                            FieldTitleTextNormal(marginTop = 3.px,
                                fontSize = 11.px,
                                text = "Please select date",
                                color = sitePalette.textErrorColor.rgb,
                                onClick = {})
                        }
                    }

                    Row(
                        horizontalArrangement = Arrangement.SpaceBetween,
                        modifier = Modifier
                            .fillMaxWidth()
                            .margin(bottom = 20.px, top = 10.px),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Box {
                            CommonButton(
                                text = "Confirm",
                                onCLick = {
                                 if (selectdate.isBlank()) {
                                        dateTimeError = true
                                    } else {
                                        scope.launch {
                                            try {
                                                isButton = true
                                                val resp = AdminRequestAssessmentPayload(
                                                    coachId = coachId,
                                                    adminId = AppGlobal.userData.uid,
                                                    adminEmail = AppGlobal.userData.email,
                                                    adminName = AppGlobal.userData.firstName,
                                                    organization = AppGlobal.userData.organization,
                                                    requestType = if(selectedRequestType == "Request Training") "request_training" else "request_match",
                                                    eventDateTime = dateToMillis(selectdate).toString(),
                                                    coachName = coachName,
                                                    seasonID = AppGlobal.selectedSeasonId


                                                )
                                                val payload = adminRequestAssessment(resp)
                                                if (payload.response.isNotEmpty()){
                                                    toastMessage("Request sent successfully")
                                                    showToast(ToastID.SUCCESS)
                                                    onDialogDismiss()
                                                }
                                                AppGlobal.updateNotifications = getCurrentMilliseconds().toString()
                                            } catch (ce:CancellationException){
                                                throw ce
                                            } catch (e:Throwable){
                                                toastMessage("${e.message}")
                                                showToast(ToastID.ERROR)
                                            } finally {
                                                isButton = false
                                            }
                                        }
                                    }
                                },
                                width = if (breakpoint < Breakpoint.MD) 115.px else 170.px,
                                height = 45.px,
                                isLoading = isButton,
                            )
                        }
                        Box {
                            CommonButton(
                                text = "Cancel",
                                onCLick = {
                                    onDialogDismiss()
                                },
                                width = if (breakpoint < Breakpoint.MD) 115.px else 170.px,
                                height = 45.px,
                                borderColor = sitePalette.primary.rgb,
                                backgroundColor = Colors.Transparent,
                                textColor = sitePalette.primary.rgb
                            )
                        }
                    }
                }

            }
        }
    }
}


